import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * "Created by <name ↗>" — the creating admin, linked to their Steam profile.
 * Same look as the match page's Created-by line. Used on the Teams, Seasons and
 * Servers admin lists (their list endpoints return created_by_steam + created_by_name).
 * Renders nothing when the row has no creator info.
 */
export default function CreatedBy({ steamId, name, style }) {
  const { t } = useTranslation();
  if (!steamId && !name) return null;
  const label = name || steamId;
  const stop = (e) => e.stopPropagation(); // rows are often clickable - don't trigger them
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: '0.72rem', fontFamily: 'var(--font-sans)', minWidth: 0, ...style }}>
      <span style={{ color: 'var(--text-muted, #4a4a5a)', fontWeight: 600, flexShrink: 0 }}>{t('matchDetail.createdBy', 'Created by')}</span>
      {steamId ? (
        <a
          href={`https://steamcommunity.com/profiles/${steamId}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={stop}
          title={t('matchDetail.openCreatorSteam', 'Open Steam profile')}
          style={{ color: 'var(--accent-blue, #3b82f6)', textDecoration: 'none', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 3, minWidth: 0 }}
        >
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>
        </a>
      ) : (
        <span style={{ color: 'var(--text-secondary, #8b8b9e)', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
      )}
    </span>
  );
}
